export default __webpack_public_path__ + "static/media/the-chosen-one.ed08ade8.jpeg";